"use strict";
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
var utils_1 = require("@material-ui/core/utils");
exports.default = utils_1.createSvgIcon(React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M15.378 16.316a7.117 7.117 0 111.438-1.438l4.186 4.186-1.438 1.438-4.186-4.186zm.821-5.7a5.084 5.084 0 11-10.167 0 5.084 5.084 0 0110.167 0z" }), "Search");
//# sourceMappingURL=Search.js.map